import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import * as motion from 'motion/react-client';
import { DemoSearchBar } from './DemoSearchBar';
import { BlockchainNetworks } from './BlockchainNetworks';

export const Home = () => {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden">
      {/* Main content container */}
      <div className="container z-10 mx-auto -mt-40 max-w-4xl px-4 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
        >
          <motion.h1
            className="text-4xl font-bold tracking-tight md:text-6xl lg:text-7xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.1, ease: 'easeOut' }}
          >
            Enhanced Block Explorer
          </motion.h1>

          {/* "Powered by" section */}
          <motion.div
            className="relative mb-8 h-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.2, ease: 'easeOut' }}
          >
            <div className="mt-4 inline-flex items-center text-3xl">
              <span className="mr-1.5 text-muted-700">Powered by</span>
              <span className="font-bold text-primary-400">700M+</span>{' '}
              <span className="ml-1.5 text-muted-800">
                {' '}
                address attributions{' '}
              </span>
            </div>
          </motion.div>

          {/* Search Component */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.3, ease: 'easeOut' }}
          >
            <DemoSearchBar />
          </motion.div>

          {/* Blockchain Networks Selector */}
          <motion.div
            className="relative z-40 mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.4, ease: 'easeOut' }}
          >
            <BlockchainNetworks />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.5, ease: 'easeOut' }}
          >
            <Button
              size="xl"
              variant="default"
              className="rounded-full font-semibold"
            >
              <Link to="/register">Get Started For Free</Link>
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};
